module.exports = require("i18next");